var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenderWatermark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "121px",
    viewBox: "0 0 104 121",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gender Watermark@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-987.000000, -213.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Panel",
    transform: "translate(254.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Female",
    transform: "translate(447.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.221952,102.451331 C395.797999,102.479292 418.829198,84.0451231 424.627902,58.104416 C430.426606,32.1637088 417.437422,5.67456691 393.379938,-5.62027616 C369.322454,-16.9151192 340.649635,-9.98603551 324.401993,11.0489586 C308.154352,32.0839528 308.69001,61.5826183 325.690622,82.0136347 L311.856148,95.8507627 L294.670467,78.6617838 C292.639053,76.7685287 289.473451,76.8243928 287.510075,78.7881448 C285.5467,80.7518968 285.490847,83.9181065 287.383739,85.9499109 L304.56942,103.13889 L287.383739,120.327869 C285.490847,122.359673 285.5467,125.525883 287.510075,127.489635 C289.473451,129.453387 292.639053,129.509251 294.670467,127.615996 L311.856148,110.427017 L329.04183,127.615996 C331.073244,129.509251 334.238846,129.453387 336.202222,127.489635 C338.165597,125.525883 338.22145,122.359673 336.328558,120.327869 L319.142877,103.13889 L332.97735,89.3017617 C343.140246,97.8058464 355.97144,102.461014 369.221952,102.451331 Z M322.820613,45.7277001 C322.820613,20.0960306 343.5952,-0.682543011 369.221952,-0.682543011 C394.848704,-0.682543011 415.623291,20.0960306 415.623291,45.7277001 C415.623291,71.3593697 394.848704,92.1379433 369.221952,92.1379433 C343.622039,92.1189837 322.87394,71.3669038 322.854984,45.7620781 L322.820613,45.7277001 Z",
    id: "Gender-Watermark"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderWatermark);
export default __webpack_public_path__ + "static/media/gender-watermark.9fec80283ec0803290472988a2a14624.svg";
export { ForwardRef as ReactComponent };